interface BreadcrumbElements {
    breadcrumbs: HTMLElement;
    items: NodeListOf<Element>;
    separators: NodeListOf<Element>;
    ellipsis?: Element | null;
    ellipsisSeparator?: Element | null;
}

document.addEventListener('DOMContentLoaded', function(): void {

    function getBreadcrumbElements(): BreadcrumbElements | null {
        const breadcrumbs: HTMLElement | null = document.getElementById('breadcrumbs') || document.querySelector('nav.breadcrumb');
        if (!breadcrumbs) return null;

        return {
            breadcrumbs,
            items: breadcrumbs.querySelectorAll('.breadcrumb-item'),
            separators: breadcrumbs.querySelectorAll('.breadcrumb-separator'),
            ellipsis: breadcrumbs.querySelector('.breadcrumb-ellipsis'),
            ellipsisSeparator: breadcrumbs.querySelector('.breadcrumb-ellipsis-separator')
        };
    }

    function addEllipsisWithSeparator(breadcrumbs: HTMLElement): void {

        const ellipsis: HTMLSpanElement = document.createElement('span');
        ellipsis.className = 'breadcrumb-ellipsis';
        ellipsis.textContent = '...';
        breadcrumbs.insertBefore(ellipsis, breadcrumbs.firstChild);

        const separator: HTMLSpanElement = document.createElement('span');
        separator.className = 'breadcrumb-separator breadcrumb-ellipsis-separator';
        separator.innerHTML = `
            <svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.603516 5.71484L5.19141 3.77539L0.603516 1.60156V0.734375L6.24023 3.52344V4.08008L0.603516 6.57617V5.71484Z" fill="#757575"></path>
            </svg>
        `;

        ellipsis.insertAdjacentElement('afterend', separator);
    }

    function setupBreadcrumbs(): void {
        const elements = getBreadcrumbElements();
        if (!elements) return;

        const { breadcrumbs, items, separators } = elements;
        let { ellipsis, ellipsisSeparator } = elements;

        if (items.length <= 2) return;

        if (!ellipsis || !ellipsisSeparator) {
            addEllipsisWithSeparator(breadcrumbs);

            ellipsis = breadcrumbs.querySelector('.breadcrumb-ellipsis');
            ellipsisSeparator = breadcrumbs.querySelector('.breadcrumb-ellipsis-separator');
        }

        if (window.innerWidth <= 644) {

            items.forEach(item => (item as HTMLElement).style.display = 'none');
            separators.forEach(sep => (sep as HTMLElement).style.display = 'none');

            const lastItem = items[items.length - 1];
            const secondLastItem = items[items.length - 2];

            if (lastItem) (lastItem as HTMLElement).style.display = 'inline-flex';
            if (secondLastItem) (secondLastItem as HTMLElement).style.display = 'inline-flex';

            if (lastItem && secondLastItem) {
                const separatorBetween = Array.from(separators).find(sep =>
                    sep.previousElementSibling === secondLastItem ||
                    sep.nextElementSibling === lastItem
                );

                if (separatorBetween) {
                    (separatorBetween as HTMLElement).style.display = 'inline-flex';
                }
            }

            if (ellipsis) (ellipsis as HTMLElement).style.display = 'inline-block';
            if (ellipsisSeparator) (ellipsisSeparator as HTMLElement).style.display = 'inline-flex';
        } else {

            items.forEach(item => (item as HTMLElement).style.removeProperty('display'));
            separators.forEach(sep => (sep as HTMLElement).style.removeProperty('display'));

            if (ellipsis) (ellipsis as HTMLElement).style.display = 'none';
            if (ellipsisSeparator) (ellipsisSeparator as HTMLElement).style.display = 'none';
        }
    }

    setupBreadcrumbs();

    window.addEventListener('resize', setupBreadcrumbs);
});